import {pricingPlanSvg as Icon__small__pricingPlanSvg} from '../Icon__small/Icon__small--pricingPlan.js';
import {pricingPlanSvg as Icon__xsmall__pricingPlanSvg} from '../Icon__xsmall/Icon__xsmall--pricingPlan.js';

export var pricingPlan = {
  name: 'pricingPlan',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pricingPlanSvg,
  alt: {
    Icon__small: Icon__small__pricingPlanSvg,
    Icon__xsmall: Icon__xsmall__pricingPlanSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
